import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function FormatIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 0V4H14L10 0Z" />
        <path d="M8 6H14V15C14 15.6 13.6 16 13 16H1C0.4 16 0 15.6 0 15V1C0 0.4 0.4 0 1 0H8V6Z" />
      </svg>
    </Icon>
  );
}
